<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="value"
    transition="scale-transition"
    min-width="290px"
    v-bind="$attrs"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="displayValue"
        :label="label"
        v-on="on"
        :prepend-icon="hideIcon ? '' : 'mdi-calendar'"
        readonly
        clearable
        @click:clear="onClear"
      ></v-text-field>
    </template>
    <v-date-picker v-model="value" color="amber darken-1" locale="vi-VN" v-bind="$attrs" scrollable>
      <v-spacer></v-spacer>
      <v-btn text color="gray" @click="menu = false">Hủy</v-btn>
      <v-btn text color="primary" @click="onDateChange">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>
<script>
import moment from 'moment'
export default {
  props: {
    label: String,
    date: String,
    hideIcon: {
      type: Boolean,
      default: false
    }
    // flat: {
    //   type: Boolean,
    //   default: false
    // },
    // filled: {
    //   type: Boolean,
    //   default: false
    // },
    // dense: {
    //   type: Boolean,
    //   default: false
    // }
  },
  data: () => ({
    menu: false,
    value: moment().format('DD/MM/YYYY')
  }),
  computed: {
    displayValue() {
      if (!this.value) {
        return ''
      }
      return moment(this.value, 'YYYY-MM-DD').format('DD/MM/YYYY')
    }
  },
  created() {
    this.value = this.date
  },
  watch: {
    date() {
      this.value = this.date
    }
  },
  methods: {
    onDateChange() {
      this.$refs.menu.save(this.value)
      this.$emit('change', this.value)
      this.menu = false
    },

    onClear() {
      this.value = ''
      this.$emit('change', '')
    }
  }
}
</script>

<style scoped></style>
